module.exports = __webpack_public_path__ + "static/work_BB_Mega_baloons_loop-c12f746ab1d87d9ab2ca5c51ac808258.mp4";